// Diário › Projetos em Grupo (0.65): a ÚNICA parte do Diário que pode ser compartilhada.
// Projetos e metas com amigos ou família: passos em checklist com quem faz cada um, data e anotações.
// Quem é convidado vê só o projeto compartilhado com ele, nunca o Meu Dia, as metas pessoais, os hábitos ou as cartas.
import { Text, View } from 'react-native';
import type { Colecao, ModDef, PainelProps } from './tipos';
import { contagem, junta, pct } from './util';
import { C } from '../components/theme';
import { N_, t } from '../lib/i18n';

function Progresso({ lista, ctx, pai }: PainelProps) {
  if (!pai || !lista.length) return null;
  const feitos = lista.filter(r => r.c.feito).length;
  const p = pct(feitos, lista.length);
  return (
    <View style={{ backgroundColor: C.card, borderRadius: 14, padding: 12, gap: 6 }}>
      <Text style={{ color: C.text, fontWeight: '800' }}>{t('{f} de {n} passos feitos', { f: feitos, n: lista.length })} · {p}%</Text>
      <View style={{ height: 8, borderRadius: 4, backgroundColor: C.card2, overflow: 'hidden' }}>
        <View style={{ width: `${p}%`, height: 8, backgroundColor: ctx.cor }} />
      </View>
    </View>
  );
}

const projeto: Colecao = {
  id: 'projeto', nome: N_('Projetos em Grupo'), um: N_('Projeto'), icone: '🤝',
  campos: [
    { k: 'titulo', r: N_('Título'), t: 'texto', ph: N_('Ex.: Viagem em família, juntar para a festa') },
    { k: 'data', r: N_('Data (opcional)'), t: 'data', aviso: [7, 1] },
    { k: 'notas', r: N_('Anotações'), t: 'longo' },
  ],
  titulo: r => r.c.titulo || '',
  sub: (r, ctx) => {
    const passos = ctx.filhos(r.id, 'passo');
    const c = contagem(r.c.data);
    return junta(passos.length ? t('{f}/{n} passos', { f: passos.filter(x => x.c.feito).length, n: passos.length }) : '', c?.txt);
  },
  data: 'data',
  agenda: r => ({ title: r.c.titulo || t('Projeto') }),
  vazio: N_('Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.'),
};

const passo: Colecao = {
  id: 'passo', pai: 'projeto', check: 'feito', nome: N_('Passos'), um: N_('Passo'), icone: r => (r.c.feito ? '✅' : '▫️'),
  campos: [
    { k: 'texto', r: N_('Passo'), t: 'texto', ph: N_('Ex.: Reservar a pousada') },
    { k: 'quem', r: N_('Quem faz'), t: 'texto', ph: N_('Nome de quem faz este passo') },
    { k: 'data', r: N_('Até quando (opcional)'), t: 'data', aviso: [1] },
    { k: 'feito', r: N_('Feito'), t: 'sim' },
    { k: 'notas', r: N_('Anotações'), t: 'longo' },
  ],
  titulo: r => r.c.texto || '', sub: r => junta(r.c.quem && '👤 ' + r.c.quem, contagem(r.c.data, !!r.c.feito)?.txt),
  feito: r => !!r.c.feito,
  painel: Progresso,
  vazio: N_('Liste os passos do projeto e diga quem faz cada um.'),
};

export const DIARIO: ModDef = { id: 'diario', colecoes: [projeto, passo] };
